import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const process = require('../env');
const util = require('../utils/index');

export const loginApi = async (formValue) => {
  try{
      console.log(process)
      const response = await axios.post(`${process.env.URL}/check/login`, formValue);
      const user = response.data
      if (response.status === 200){
        
        sessionStorage.setItem("user", JSON.stringify(user))
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

